import { takeEvery, put, CallEffect, PutEffect } from 'redux-saga/effects';
import { InitActionTypes } from '../actions';
import { GetInviteInfo, getInviteInfo } from '../actions/inviteActions';
import { Logout, logOut, SetMode, setMode } from '../actions/loginAndRegisterActions';
import { RequestActionType, requestError, requestSuccess } from '../actions/requestActions';
import { Mode } from '../models/commonEnums';
import RequestActions from '../models/RequestTypes';
import { RequestType } from '../reducers/requestReducer';
import history from '../store/history';
import { getUrlVars } from '../utils';
import { toErrorType } from './isErrorType';

const isIEBrowser = (): boolean => !!navigator.userAgent.match(/MSIE/g) || !!navigator.userAgent.match(/Trident/g);

const hasNoLocalStorage = (): boolean => {
    try {
        const test = 'test';
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return false;
    } catch (e) {
        return true;
    }
};

type initializeAppSaga = Generator<
    | CallEffect<undefined | Promise<string>>
    | PutEffect<GetInviteInfo>
    | PutEffect<SetMode>
    | PutEffect<Logout>
    | RequestActions,
    void,
    string
>;

export function* initializeAppSaga(): initializeAppSaga {
    const queryParams = getUrlVars(window.location.search);
    try {
        if (isIEBrowser() || hasNoLocalStorage()) {
            // check, if browser is IE
            history.push('/not-supported');
        } else {
            yield put(logOut());
            if (queryParams.inviteId) {
                yield put(getInviteInfo(queryParams.inviteId));
            }
            if (queryParams.theme === 'dark') {
                document.body.setAttribute('data-theme', 'dark');
            }
            if (queryParams.mode && Object.keys(Mode).includes(queryParams.mode)) {
                document.body.className = queryParams.mode;
                yield put(setMode(queryParams.mode as Mode));
            } else {
                if (queryParams.client_id == `6c39b271-9361-407f-9317-1c302bcd6c3a`) {
                    document.body.className = Mode.pro_app;
                } else {
                    document.body.className = Mode.b2b_desktop;
                }
            }
        }
        yield put(requestSuccess(RequestType.Initialize, RequestActionType.Success));
    } catch (error) {
        const errorAsErrorType = toErrorType(error);
        yield put(requestError(errorAsErrorType, RequestType.Initialize, RequestActionType.Error));
    }
}

export default function* (): Generator {
    yield takeEvery(InitActionTypes.InitializeInit, initializeAppSaga);
}
